<footer class="site_footer ut_spc">
  <div class="container">
    <div class="ftr_box">
      <figure class="logo">
        <img src="{{ assetsConst.logo }}" alt="logo" />
      </figure>
      <p>
        It is a long established fact that a reader will be distracted by the
        readable content of a page when looking at its layout.
      </p>
    </div>
    <div class="ftr_box hd_3_1">
      <h4>NEED HELP ?</h4>
      <ul class="footer_menu">
        @for (item of needHelp; track $index) {
          <li>
            <span [routerLink]="item.path">{{ item.title }}</span>
          </li>
        }
      </ul>
    </div>

    <div class="ftr_box hd_3_1">
      <h4>Our Company</h4>
      <ul class="footer_menu">
        @for (item of ourCompany; track $index) {
          <li>
            <span [routerLink]="item.path">{{ item.title }}</span>
          </li>
        }
      </ul>
    </div>

    <div class="ftr_box hd_3_1">
      <h4>Social Link</h4>
      <ul class="footer_menu social_menu">
        <li>
          <figure matTooltip="Facebook" matTooltipPosition="below">
            <img src="{{ assetsConst.fbIcon }}" alt="icon" />
          </figure>
        </li>
        <li>
          <figure matTooltip="Twitter" matTooltipPosition="below">
            <img src="{{ assetsConst.twiterIcon }}" alt="icon" />
          </figure>
        </li>
        <li>
          <figure matTooltip="Instagram" matTooltipPosition="below">
            <img src="{{ assetsConst.instaIcon }}" alt="icon" />
          </figure>
        </li>
      </ul>
    </div>
  </div>
  <div class="copy_right text_center">
    <p>Copyright {{ currentYear }} - All right Recived by FGSN</p>
  </div>
</footer>
